/**
 * Getting specific url param
 *
 * @param {string} target
 * @returns {null||string}
 */
export const getUrlParamByName = (target = null) => {
	const search = window.location.search;
	let value = null;

	if (search) {
		const params = search.substring(1);

		if (params.indexOf('=') !== -1) {
			const arrOfPairs = params.split('&');
			const searchValue = arrOfPairs.filter(pair => {
				const arrPair = pair.split('=');
				return target && arrPair[1] && target === arrPair[0];
			});

			if (searchValue[0]) {
				value = searchValue[0].split('=')[1];
			}
		}
	}

	return value;
};

/**
 * Getting all url params for current url
 *
 * @param {string} target
 * @param {array} validNames
 * @returns {null||object}
 */
export const getUrlParams = (target = '', validNames = null) => {
	const search = target || window.location.search;
	let value = null;
	if (search) {
		const params = search.substring(1);

		if (params.indexOf('=') !== -1) {
			const arrOfPairs = params.split('&');

			arrOfPairs.map(pair => {
				const arrPair = pair.split('=');

				if ((arrPair[1] && !validNames) || (arrPair[1] && validNames.includes(arrPair[0]))) {
					value = {
						...value,
						[arrPair[0]]: decodeURI(arrPair[1]),
					};
				}

				return null;
			});
		}
	}

	return value;
};

/**
 * Returns url params string
 *
 * @param {string} target
 * @returns {string}
 */
export const getUrlParamsString = (target = '') => {
	const search = target || window.location.search;
	if (search) {
		return `?${search.substring(1)}`;
	}
	return '';
};

/**
 * Convert object to url params
 *
 * @param {object} data
 * @returns {string}
 */
export const objectToUrlParams = data => {
	let value = '';
	if (data && typeof data === 'object') {
		Object.entries(data).forEach((itm, index, arr) => {
			const [key, val] = itm;
			const valueExist = val !== null && val !== undefined && val !== '';

			if (index === 0) value = '?';
			if (valueExist && Array.isArray(val) && val.length) value += `${key}=${encodeURI(JSON.stringify(val))}`;
			else if (valueExist && !Array.isArray(val)) value += `${key}=${encodeURI(val)}`;
			if (arr.length - 1 !== index && valueExist) value += '&';
		});
	}
	if (value === '?&') value = '';
	return value;
};

/**
 * Decode string what contain array of primitive values and return valid array.
 *
 * @param {string} encodedString
 * @returns {array}
 */
export const decodeUrlArray = encodedString => JSON.parse(decodeURI(encodedString)).map(itm => `${itm}`);
